import service from '../services/breadorders.service';
import { BreadOrder, Bread } from '../models/BreadOrder';

export async function createBreadOrder({
    date,
    time,
    firstName,
    lastName,
    phoneNumber,
    bread,
    comments,
    cashier,
    customerId = null
}: {
    date: string;
    time: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    bread: Array<Bread>;
    comments: string;
    cashier: string;
    customerId?: string | null;
}) {
    console.log("Helper creatong bread order with bread:", bread)
    return await service.createBreadOrder(date, time, firstName, lastName, phoneNumber, bread, comments, cashier, new Date(), customerId);
}

export async function editBread(breadOrder: BreadOrder) {
    console.log('Editing bread order:', breadOrder);
    await service.editBreadOrder(breadOrder.id, breadOrder);
}

export async function deleteBreadOrder(breadOrderId: string) {
    console.log('Deleting bread order:', breadOrderId);
    await service.deleteBreadOrder(breadOrderId);
}

export async function getBreads() {
    return await fetchBreads();
}

export async function fetchBreads() {
    console.log('Fetching breads from API');
    const breads = await service.fetchBreads();
    localStorage.setItem('breadData', JSON.stringify(breads));
    return breads;
}

export async function clearCache() {
    localStorage.removeItem('breadData');
}


export function convertStringToArray(bread: string) {
    try {
        return JSON.parse(bread);
    } catch {
        console.error('Failed to parse bread string:', bread);
        return [];
    }
}

